class GPSProviderTelematicPropModel extends App.Models.BaseModel {
    modelUrl = 'GPSProviderTelematicProp';
}

App.Models.GPSProviderTelematicProp = GPSProviderTelematicPropModel;
